import { defaultApi } from "@/api";

export const getSavedWorkspaces = async () => {
  const response: { data: { filters: any; defaultColumns: any; userColumns: any; preConfiguredColumns: any } } =
    await defaultApi.apiVersion1.workspace.getAll();
  return response.data;
};

export const saveWorkspace = async (workspacePayload) => {
  const response = await defaultApi.apiVersion1.userFilters.updateAll(workspacePayload);
  return response;
};
